import React, { Component } from 'react';
import { Text, View, FlatList, TouchableOpacity, Dimensions, Alert } from '../../src/web/react-native';
import AsyncStorage from '../../src/services/storage';
import Icon from '../../src/components/Icon';
import Service from './../../Service/service';
import moment from 'moment';
import store from './../../store';
import { connect } from 'react-redux';
import {
  UpdateShiftLogActionAsync,
  UpdateTeamShiftLogActionAsync,
} from './../../Action/ShiftLogAction';
import { editingActions, shiftLogActions } from '../../src/store';
import { LoadingOverlay } from '../../src/components';
import { Route } from '../../src/app/Route';
import { DdLogs } from '../../src/logging/datadog';

export class ShiftLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      downloadStatus: !!this.props.item.fileContent == true ? 'Downloaded' : 'Download',
    };
  }
  renderStatusTag = () => {
    if (this.props.isPrev) {
      return (
        <View
          style={{
            display: 'flex',
            borderRadius: 4,
            backgroundColor: '#D1D1D1',
            paddingHorizontal: 3,
            marginRight: 5,
          }}>
          <Text style={{ color: '#3B3B3B', fontSize: 14 }}>Prev Shift</Text>
        </View>
      );
    } else if (this.props.isCurrent) {
      return (
        <View
          style={{
            display: 'flex',
            borderRadius: 4,
            backgroundColor: '#FFF2DD',
            paddingHorizontal: 3,
            marginRight: 5,
          }}>
          <Text style={{ color: '#F2AC33', fontSize: 14 }}>Current Shift</Text>
        </View>
      );
    } else {
      return <View style={{ display: 'none' }}></View>;
    }
  };
  renderUser = () => {
    return (
      <React.Fragment>
        <Text style={{ fontSize: 12, color: '#5A5A5A' }}>{this.props.description + ' By'}</Text>
        <Text style={{ color: '#5A5A5A' }}>{this.props.user}</Text>
      </React.Fragment>
    );
  };
  async requestPDF() {
    let { site } = await Service.getLocalPreferences();
    let siteCode = site.siteCode;
    let { shiftSummaryID, lastUpdate } = this.props.item;
    DdLogs.info('isteamlog' + this.props.isTeamLog + '  **' + shiftSummaryID);
    // this.props.Update()
    // console.log(this.props.item)
    this.setState({
      downloadStatus: 'Downloading',
    });
    if (this.props.isTeamLog) {
      DdLogs.info('teamlogs is downloading');
      this.props
        .UpdateTeamShiftLog(siteCode, shiftSummaryID, lastUpdate)
        .then((res) => {
          this.setState({
            downloadStatus: 'Downloaded',
          });
        })
        .catch((err) => {
          DdLogs.error('Failed to update team shift log', err);
          this.setState({
            downloadStatus: 'Download',
          });
          setTimeout(() => {
            Alert.alert('Error', 'Unable to update team shift logs, please try again later.');
          }, 200);
        });
    } else {
      this.props
        .UpdateShiftLog(siteCode, shiftSummaryID, lastUpdate) // Uses UpdareShiftLog action to fetch the fileContent? yes..
        .then((res) => {
          this.setState({
            downloadStatus: 'Downloaded',
          });
        })
        .catch((err) => {
          this.setState({
            downloadStatus: 'Download',
          });
          setTimeout(() => {
            Alert.alert('Error', 'Unable to update the shift log, please try again later.');
          }, 200);
        });
    }
  }
  setDownloadStatus(status) {
    this.setState({
      downloadStatus: status,
    });
  }

  async shiftLogClickHandler(canEditShiftLog) {
    if (this.props.item.status === 'InProgress') {
      this.setState({
        isLoading: true,
      });
      let { site } = await Service.getLocalPreferences();
      let siteCode = site.siteCode;
      let { shiftSummaryID } = this.props.item;
      this.props.GetShiftLogDetails(siteCode, shiftSummaryID).then((res) => {
        this.setState({
          isLoading: false,
        });
        if (res.error) {
          Alert.alert(
            'Error',
            'Unable to view the shift log details, please try again or check permissions.',
          );
        } else {
          this.props.SetEditingMode(canEditShiftLog ? 'edit' : 'readOnly');
          this.props.navigation.navigate(Route.editShiftLogScreen, {
            isTeamLog: this.props.isTeamLog,
          });
        }
      });
    } else {
      this.props.navigation.navigate(Route.logDetailsScreen, {
        item: this.props.item,
        isTeamLog: this.props.isTeamLog,
        setDownloadStatus: this.setDownloadStatus.bind(this),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item.fileContent != this.props.item.fileContent) {
      this.setState({
        downloadStatus: !!this.props.item.fileContent == true ? 'Downloaded' : 'Download',
      });
    }
  }

  renderDownloadButton() {
    let { status } = this.props.item;
    return (
      (status == 'Submitted' || status == 'TakenOver') && (
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}>
          {this.state.downloadStatus != 'Download' ? (
            <View
              style={{
                marginLeft: -10,
                marginRight: 5,
                backgroundColor: '#EEF3F4',
                borderRadius: 5,
              }}>
              <Text style={{ padding: 5 }}>{this.state.downloadStatus}</Text>
            </View>
          ) : (
            <TouchableOpacity onPress={() => this.requestPDF()}>
              <View
                style={{
                  marginLeft: -10,
                  marginRight: 5,
                  backgroundColor: '#00A3E0',
                  borderRadius: 5,
                }}>
                <Text style={{ color: '#fff', padding: 5 }}>{this.state.downloadStatus}</Text>
              </View>
            </TouchableOpacity>
          )}
        </View>
      )
    );
  }
  render() {
    let {
      approveTime,
      approveUser,
      assetName,
      createTime,
      createUser,
      fileContent,
      filename,
      path,
      shiftEnd,
      shiftStart,
      shiftSummaryID,
      status,
      submitTime,
      submitUser,
      takeoverDisplay,
      takeoverTime,
      takeoverUser,
      templateName,
    } = this.props.item;

    let width = this.props.width;
    let description = this.props.description;
    let displayStatus = '';
    let navigation = this.props.navigation;
    let displayDate = this.props.displayDate;
    if (status === 'Submitted' || status === 'PreSubmission') {
      displayStatus = 'Submitted';
    } else if (status === 'TakenOver') {
      displayStatus = 'Taken Over';
    } else {
      displayStatus = 'In Progress';
    }

    const canEditShiftLog = status === 'InProgress' && createUser === this.props.currentUser;

    return (
      <React.Fragment>
        {<LoadingOverlay visible={this.state.isLoading} />}
        <TouchableOpacity onPress={() => this.shiftLogClickHandler(canEditShiftLog)}>
          <View
            style={{
              flex: 1,
              height: 140,
              backgroundColor: '#fff',
              borderTopWidth: 2,
              borderTopColor: '#f3f7fa',
            }}>
            <View style={{ width: 0.94 * width, paddingLeft: 5, paddingRight: 5 }}>
              {/*************     Header row      *************/}
              <View
                style={{
                  height: 43,
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingTop: 3,
                }}>
                <View style={{ flex: 1, flexDirection: 'row' }}>
                  <Text
                    style={{
                      flex: 1,
                      flexWrap: 'wrap',
                      fontWeight: 'bold',
                      fontSize: 16,
                    }}>
                    {templateName}
                  </Text>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      position: 'absolute',
                      height: 20,
                      right: 5,
                    }}>
                    {this.renderStatusTag()}
                    <View
                      style={[
                        getTextStyle(description, false),
                        { borderRadius: 4, paddingHorizontal: 3 },
                      ]}>
                      <Text style={[getTextStyle(description, true)]}>{displayStatus}</Text>
                    </View>
                  </View>
                </View>
              </View>

              {/*************     Middle row      *************/}
              <View
                style={{
                  height: 40,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <View style={{ width: 0.55 * width }}>{this.renderUser()}</View>
                <View
                  style={{
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}>
                  <View style={{ marginLeft: -10 }}>
                    <Text style={{ fontSize: 12, color: '#5A5A5A' }}>Assets</Text>
                    <Text style={{ color: '#5A5A5A' }}>{assetName}</Text>
                  </View>
                  {<Icon name="angle-right" size={29} color="#CDCDCD" />}
                </View>
              </View>

              {/*************     Botton row      *************/}
              <View
                style={{
                  height: 40,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <View style={{ width: 0.55 * width }}>
                  <Text style={{ fontSize: 10, color: '#5A5A5A' }}>{description + ' Date'}</Text>
                  <Text style={{ color: '#5A5A5A' }}>{displayDate}</Text>
                </View>
                {this.renderDownloadButton()}
              </View>
            </View>
          </View>
        </TouchableOpacity>
      </React.Fragment>
    );
  }
}
function getTextStyle(description, isText) {
  //This logic is broken :) BUT can resuse the intended color scheme. Note that InProgress == Created
  if (description == 'InProgress') {
    if (isText) {
      return {
        color: '#F2AC33',
      };
    } else {
      return {
        backgroundColor: '#FFF2DD',
      };
    }
  } else if (description === 'Submitted') {
    if (isText) {
      return {
        color: '#00A3E0',
      };
    } else {
      return {
        backgroundColor: '#E9F9FF',
      };
    }
  } else {
    //TakenOver
    if (isText) {
      return {
        color: '#97B206',
      };
    } else {
      return {
        backgroundColor: '#F6FAE2',
      };
    }
  }
}

const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.shiftLogs,
  teamShiftLogs: state.shiftLogs.teamShiftLogs,
  currentUser: state.user.user?.name,
});

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateShiftLog: (siteCode, shiftSummaryID, lastUpdate) => {
      return dispatch(
        UpdateShiftLogActionAsync({
          siteCode,
          shiftSummaryID,
          lastUpdate,
        }),
      );
    },
    UpdateTeamShiftLog: (siteCode, shiftSummaryID, lastUpdate) => {
      return dispatch(
        UpdateTeamShiftLogActionAsync({
          siteCode,
          shiftSummaryID,
          lastUpdate,
        }),
      );
    },
    GetShiftLogDetails: (siteCode, shiftSummaryID) => {
      const res = dispatch(
        shiftLogActions.fetchShiftLogDetails({
          siteCode: siteCode,
          shiftSummaryID: shiftSummaryID,
        }),
      );
      DdLogs.info(`get shift log details: ${res}`);
      return res;
    },
    SetEditingMode: (mode) => {
      return dispatch(editingActions.setMode(mode));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShiftLogs);